export default [
  {
    title: '计划名称',
    key: 'planName',
    width: 173,
    fixed: true,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: 150,
    fixed: true,
    type: 'basic'
  },
  {
    title: '投放计划ID',
    key: 'planId',
    width: 86,
    overflow: true,
    type: 'basic'
  },
  {
    title: '媒体计划ID(关键词ID)',
    key: 'mediaPlanId',
    width: 165,
    type: 'basic'
  },
  {
    title: '渠道商帐号',
    key: 'channelUserName',
    width: 94,
    overflow: true,
    type: 'basic'
  },
  {
    title: '投放媒体',
    key: 'mediaName',
    width: 82,
    type: 'basic'
  },
  {
    title: '媒体账号',
    key: 'mediaAccount',
    width: 144,
    overflow: true,
    type: 'basic'
  },
  {
    title: '投放位',
    key: 'advPositionName',
    overflow: true,
    width: 82,
    type: 'basic'
  },
  {
    title: '投放方式',
    key: 'launchType',
    width: 108,
    type: 'basic'
  },
  {
    title: '投放游戏',
    key: 'gameName',
    overflow: true,
    width: 112,
    type: 'basic'
  },
  {
    title: '投放时间',
    key: 'launchTime',
    width: 82,
    type: 'basic'
  },
  {
    title: '投放人',
    key: 'launchOpName',
    width: 96,
    type: 'basic'
  },
  {
    title: '投放平台',
    key: 'platform',
    width: 96,
    type: 'basic'
  },
  {
    title: '素材选择',
    key: 'imageName',
    width: 93,
    type: 'basic'
  },
  {
    title: '落地页选择',
    key: 'pageId',
    width: 108,
    type: 'basic'
  },
  {
    title: '点击监测链接',
    key: 'trackChainAddr',
    overflow: true,
    width: 140,
    type: 'basic'
  },
  {
    title: '曝光追踪短链',
    key: 'pvChainAddr',
    overflow: true,
    width: 140,
    type: 'basic'
  },
  {
    title: '包下载地址',
    key: 'gamePackAddr',
    overflow: true,
    width: 140,
    type: 'basic'
  },
  {
    title: '渠道包媒体标识',
    key: 'mediaPackExtendId',
    overflow: true,
    width: 140,
    type: 'basic'
  },
  {
    title: '华为智能分包',
    key: 'planMediaExt',
    overflow: true,
    width: 140,
    type: 'basic'
  },
  {
    title: '打包状态',
    key: 'packageStatus',
    width: 90,
    type: 'basic'
  },
  {
    title: '落地页地址',
    key: 'pageAddr',
    overflow: true,
    width: 140,
    type: 'basic'
  },
  {
    title: '中转短链',
    key: 'field4',
    overflow: true,
    width: 140,
    type: 'basic'
  },
  {
    title: '外投授权',
    key: 'proxyAccountName',
    width: 123,
    type: 'basic'
  }
]
